import {tns} from "tiny-slider/src/tiny-slider";

const instances = [];

/**
 * @param {HTMLElement} element
 */
function getOptions(element) {
  if (element.id === 'home-slider') {
    return {
      container: '#home-slider .slider__items',
      items: 1,
      controls: true,
      controlsPosition: "bottom",
      controlsContainer: element.querySelector('.slider__controls'),
      loop: true,
      nav: false,
      autoplay: false,
      autoplayButtonOutput: false,
      animateIn: 'slideInLeft',
      animateOut: 'slideOutRight'
    };
  }

  if (element.id === 'post-slider') {
    return {
      container: '#post-slider .slider__items',
      items: 1,
      controls: true,
      controlsContainer: element.querySelector('.slider__controls'),
      loop: true,
      nav: false,
      autoplay: true,
      autoplayButton: false,
      animateIn: 'slideInLeft',
      animateOut: 'slideOutRight'
    };
  }

}

/**
 * @param {NodeList} elements
 */
export default function initializeSliders(elements) {
  elements.forEach((element) => {
      instances.push(
        tns(getOptions(element))
      );
    });
}
